import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33008554"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  key: 0,
  class: "card-title"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Edit Master Invoice  ")
const _hoisted_5 = {
  key: 1,
  class: "card-title"
}
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "invoiceType",
  class: "form-label"
}, "Tipe Invoice", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Pilih Tipe Invoice", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "title",
  class: "form-label"
}, "Nama Invoice", -1))
const _hoisted_14 = { class: "col-lg-6 mt-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "sekolah",
  class: "form-label"
}, "Sekolah", -1))
const _hoisted_16 = { class: "col-lg-6 mt-4" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Daftar Sekolah ")
const _hoisted_18 = {
  key: 0,
  class: "fas fa-caret-down"
}
const _hoisted_19 = {
  key: 1,
  class: "fas fa-caret-up"
}
const _hoisted_20 = {
  key: 0,
  style: {"max-height":"120px","overflow-y":"auto","display":"flex","gap":"0.3rem","flex-direction":"column"}
}
const _hoisted_21 = { class: "row mb-6" }
const _hoisted_22 = { class: "col-lg-6" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "invoiceType",
  class: "form-label"
}, "Jenis Invoice", -1))
const _hoisted_24 = { class: "d-flex gap-3" }
const _hoisted_25 = { class: "d-flex gap-2" }
const _hoisted_26 = ["checked"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "SEKALI"
}, " Sekali ", -1))
const _hoisted_28 = { class: "d-flex gap-2" }
const _hoisted_29 = ["checked"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "BERULANG"
}, " Berulang ", -1))
const _hoisted_31 = {
  key: 0,
  class: "col-lg-6"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "isNameAutoGenerated",
  class: "form-label"
}, "Pilihan Invoice Berulang", -1))
const _hoisted_33 = { class: "d-flex gap-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isNameAutoGenerated"
}, " Buat Nama Invoices otomatis sesuai jenis invoices ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "repeatType",
  class: "form-label"
}, "Jenis Invoice Berulang", -1))
const _hoisted_37 = { class: "d-flex gap-3" }
const _hoisted_38 = { class: "d-flex gap-2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "BULANAN"
}, " Bulanan ", -1))
const _hoisted_40 = { class: "d-flex gap-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "TAHUNAN"
}, " Tahunan ", -1))
const _hoisted_42 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_43 = { class: "col-lg-6" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "form-label"
}, "Tanggal Invoice", -1))
const _hoisted_45 = { class: "col-lg-6" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "form-label"
}, "Tanggal Jatuh Tempo", -1))
const _hoisted_47 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_48 = {
  key: 0,
  class: "col-lg-3"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "form-label"
}, "Bulan Berulang", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Pilih Tanggal Berulang", -1))
const _hoisted_51 = ["value"]
const _hoisted_52 = {
  key: 1,
  class: "col-lg-3"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "form-label"
}, "Tanggal Berulang", -1))
const _hoisted_54 = ["disabled"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Pilih Tanggal Berulang", -1))
const _hoisted_56 = ["value"]
const _hoisted_57 = ["value"]
const _hoisted_58 = ["value"]
const _hoisted_59 = {
  key: 2,
  class: "col-lg-6"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "form-label"
}, "Tanggal Berulang", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Pilih Tanggal Berulang", -1))
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "col-lg-6" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "form-label"
}, "Jatuh Tempo", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "x day dari tanggal berulang", -1))
const _hoisted_66 = { class: "col-lg-6" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "form-label"
}, "Tanggal Mulai Invoice", -1))
const _hoisted_68 = { class: "col-lg-6" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "form-label"
}, "Tanggal Akhir Invoice", -1))
const _hoisted_70 = { class: "row mb-6" }
const _hoisted_71 = { class: "col-lg-6" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "file",
  class: "form-label"
}, "Lampiran", -1))
const _hoisted_73 = ["src"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Detail Invoice", -1))
const _hoisted_75 = { class: "table dense-table align-middle gs-0 gy-4" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", null, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Detail"),
    /*#__PURE__*/_createElementVNode("th", null, "Nominal"),
    /*#__PURE__*/_createElementVNode("th", null, "Qty"),
    /*#__PURE__*/_createElementVNode("th", null, "Sub Total"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_77 = { class: "d-flex gap-2" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_81 = { class: "d-flex gap-2" }
const _hoisted_82 = ["disabled"]
const _hoisted_83 = { class: "bg-secondary" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "text-end"
}, "Sub Total", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_86 = { class: "bg-secondary" }
const _hoisted_87 = {
  colspan: "4",
  class: "text-end"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_89 = { class: "bg-secondary" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "text-end"
}, "Total Biaya", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_92 = { class: "card-footer d-flex justify-content-end gap-1" }
const _hoisted_93 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      active: _ctx.isLoading,
      "is-full-page": true,
      color: "#007BFF",
      "background-color": "#A3A3A3",
      opacity: "0.5"
    }, null, 8, ["active"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.id)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("span", {
                class: _normalizeClass(["badge text-uppercase", _ctx.isPublished ? 'badge-success' : 'badge-warning'])
              }, _toDisplayString(_ctx.isPublished ?
          "Published" : "draft"), 3)
            ]))
          : (_openBlock(), _createElementBlock("h3", _hoisted_5, "Add Master Invoice"))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.invoiceType) = $event)),
              id: "invoiceType",
              class: "form-select form-select-sm"
            }, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceSettingList, (item, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item._id
                }, _toDisplayString(item.title), 9, _hoisted_11))
              }), 256))
            ], 512), [
              [_vModelSelect, _ctx.invoiceType]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.title) = $event)),
              id: "title",
              type: "text",
              class: "form-control form-control-sm"
            }, null, 512), [
              [_vModelText, _ctx.title]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.schoolId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.schoolId) = $event)),
              placeholder: "Pilih Sekolah",
              mode: "multiple",
              options: _ctx.ListSchool,
              searchable: true,
              label: "name",
              id: "sekolah",
              "track-by": "name",
              "value-prop": "id",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pilihSekolah($event))),
              hideSelected: false,
              loading: _ctx.loadingComboSchool
            }, null, 8, ["modelValue", "options", "loading"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", {
              for: "sekolah",
              class: "form-label cursor-pointer user-select-none",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openListSchool = !_ctx.openListSchool))
            }, [
              _hoisted_17,
              (_ctx.openListSchool)
                ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                : _createCommentVNode("", true),
              (!_ctx.openListSchool)
                ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                : _createCommentVNode("", true)
            ]),
            (_ctx.openListSchool)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schoolName, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "fs-7 text-uppercase",
                      key: 'daftar-' + index
                    }, _toDisplayString(item), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createTextVNode(" " + _toDisplayString(_ctx.type) + " ", 1),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.type) = $event)),
                  class: "form-check-input",
                  type: "radio",
                  name: "invoiceType",
                  id: "SEKALI",
                  value: "SEKALI",
                  checked: _ctx.type === 'SEKALI'
                }, null, 8, _hoisted_26), [
                  [_vModelRadio, _ctx.type]
                ]),
                _hoisted_27
              ]),
              _createElementVNode("div", _hoisted_28, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.type) = $event)),
                  class: "form-check-input",
                  type: "radio",
                  name: "invoiceType",
                  id: "BERULANG",
                  value: "BERULANG",
                  checked: _ctx.type === 'BERULANG'
                }, null, 8, _hoisted_29), [
                  [_vModelRadio, _ctx.type]
                ]),
                _hoisted_30
              ])
            ])
          ]),
          (_ctx.type === 'BERULANG')
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isNameAutoGenerated) = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    name: "isNameAutoGenerated",
                    id: "isNameAutoGenerated",
                    value: "false"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.isNameAutoGenerated]
                  ]),
                  _hoisted_34
                ]),
                _hoisted_35,
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.repeatType) = $event)),
                      class: "form-check-input",
                      type: "radio",
                      name: "repeatType",
                      id: "BULANAN",
                      value: "BULANAN"
                    }, null, 512), [
                      [_vModelRadio, _ctx.repeatType]
                    ]),
                    _hoisted_39
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.repeatType) = $event)),
                      class: "form-check-input",
                      type: "radio",
                      name: "repeatType",
                      id: "TAHUNAN",
                      value: "TAHUNAN"
                    }, null, 512), [
                      [_vModelRadio, _ctx.repeatType]
                    ]),
                    _hoisted_41
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.type === 'SEKALI')
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.invoiceDate) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.invoiceDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dueDate) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.dueDate]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.type === 'BERULANG')
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              (_ctx.repeatType === 'TAHUNAN')
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _hoisted_49,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.invoiceMonth) = $event)),
                      onChange: _cache[13] || (_cache[13] = 
            (e) => {
              _ctx.invoiceDate = '';
            }
          )
                    }, [
                      _hoisted_50,
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                        return _createElementVNode("option", { value: i }, _toDisplayString(_ctx.moment()
                  .set("month", i - 1)
                  .format("MMMM")), 9, _hoisted_51)
                      }), 64))
                    ], 544), [
                      [_vModelSelect, _ctx.invoiceMonth]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.repeatType === 'TAHUNAN')
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _hoisted_53,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control form-control-sm",
                      disabled: !_ctx.invoiceMonth,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.invoiceDate) = $event))
                    }, [
                      _hoisted_55,
                      (_ctx.invoiceMonth == 2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(28, (i) => {
                            return _createElementVNode("option", { value: i }, _toDisplayString(i), 9, _hoisted_56)
                          }), 64))
                        : ([4, 6, 9, 11].includes(_ctx.invoiceMonth))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(30, (i) => {
                              return _createElementVNode("option", { value: i }, _toDisplayString(i), 9, _hoisted_57)
                            }), 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, _renderList(31, (i) => {
                              return _createElementVNode("option", { value: i }, _toDisplayString(i), 9, _hoisted_58)
                            }), 64))
                    ], 8, _hoisted_54), [
                      [_vModelSelect, _ctx.invoiceDate]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.repeatType === 'BULANAN')
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _hoisted_60,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.invoiceDate) = $event))
                    }, [
                      _hoisted_61,
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (i) => {
                        return _createElementVNode("option", { value: i }, _toDisplayString(i), 9, _hoisted_62)
                      }), 64))
                    ], 512), [
                      [_vModelSelect, _ctx.invoiceDate]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dueDate) = $event)),
                  min: "0"
                }, null, 512), [
                  [_vModelText, _ctx.dueDate]
                ]),
                _hoisted_65
              ]),
              _createElementVNode("div", _hoisted_66, [
                _hoisted_67,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.startInvoice) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.startInvoice]
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _hoisted_69,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.endInvoice) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.endInvoice]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _hoisted_72,
            _createElementVNode("input", {
              name: "file",
              id: "file",
              type: "file",
              class: "form-control form-control-sm",
              onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleFileUpload($event))),
              accept: "image/x-png,image/jpeg"
            }, null, 32),
            (_ctx.urlImage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  alt: "file1",
                  class: "img-fluid",
                  src: _ctx.urlImage
                }, null, 8, _hoisted_73))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_74,
        _createElementVNode("table", _hoisted_75, [
          _hoisted_76,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: invoice.id
              }, [
                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                _createElementVNode("td", null, _toDisplayString(invoice.name), 1),
                _createElementVNode("td", null, "Rp." + _toDisplayString(_ctx.formatPrice(invoice.amount)), 1),
                _createElementVNode("td", null, _toDisplayString(invoice.quantity), 1),
                _createElementVNode("td", null, "Rp." + _toDisplayString(_ctx.formatPrice(invoice.totalAmount)), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("button", {
                      class: "btn btn-danger",
                      onClick: ($event: any) => (_ctx.deleteInvoice(index))
                    }, " Delete ", 8, _hoisted_78)
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("tr", null, [
              _hoisted_79,
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control form-control-sm",
                  type: "text",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.addData.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.addData.name]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control form-control-sm",
                  type: "text",
                  onKeydown: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onlyNumber && _ctx.onlyNumber(...args))),
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.addData.amount) = $event))
                }, null, 544), [
                  [_vModelText, _ctx.addData.amount]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control form-control-sm",
                  type: "text",
                  onKeydown: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onlyNumber && _ctx.onlyNumber(...args))),
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.addData.quantity) = $event))
                }, null, 544), [
                  [_vModelText, _ctx.addData.quantity]
                ])
              ]),
              _hoisted_80,
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("button", {
                    disabled: !_ctx.addData.name || !_ctx.addData.amount || !_ctx.addData.quantity
                  ,
                    class: "btn btn-info",
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.addDetailInvoice()))
                  }, " Tambah ", 8, _hoisted_82)
                ])
              ])
            ]),
            _createElementVNode("tr", _hoisted_83, [
              _hoisted_84,
              _createElementVNode("td", null, "Rp." + _toDisplayString(_ctx.formatPrice(_ctx.subTotal)), 1),
              _hoisted_85
            ]),
            _createElementVNode("tr", _hoisted_86, [
              _createElementVNode("td", _hoisted_87, "Pajak (" + _toDisplayString(_ctx.tax) + "%)", 1),
              _createElementVNode("td", null, "Rp." + _toDisplayString(_ctx.formatPrice(_ctx.taxAmount)), 1),
              _hoisted_88
            ]),
            _createElementVNode("tr", _hoisted_89, [
              _hoisted_90,
              _createElementVNode("td", null, "Rp." + _toDisplayString(_ctx.formatPrice(_ctx.totalAmount)), 1),
              _hoisted_91
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_92, [
        (!_ctx.isPublished && _ctx.id)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-warning",
              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.publishInvoice && _ctx.publishInvoice(...args)))
            }, " Publish "))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn-primary",
          disabled: _ctx.invoices.length == 0,
          onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.saveInvoice && _ctx.saveInvoice(...args)))
        }, " Simpan ", 8, _hoisted_93),
        _createElementVNode("button", {
          class: "btn btn-danger",
          onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.cancelInvoice && _ctx.cancelInvoice(...args)))
        }, "Kembali")
      ])
    ])
  ], 64))
}